/**
 * Store pro modální dialogy.
 */

import {SHOW, HIDE, CHANGE_SIZE, CHANGE_TITLE} from './ModalActions'

/** Init state. */
const initialState = {
    components: [],         // pole aktuálně otevřených dialogů, obsahuje objekty {component: <odkaz na komponentu, jen reference, ne instance>, componentProps: <props pro komponentu>, title: <titulek dialogu>}
    customSize: [],       // nová definice velikosti dynamicky změněná pro konkrétní dialog
};

export default function modalDialog(state = initialState, action) {
    switch (action.type) {
        case SHOW:
            return {
                ...state,
                components: [
                    ...state.components,
                    {
                        component: action.component,
                        componentProps: action.componentProps,
                        title: action.title,
                        modalProps: action.modalProps,
                    }
                ],
                customSize: [
                    ...state.customSize,
                    null
                ]
            };
        case HIDE:
            return {
                ...state,
                components: [
                    ...state.components.slice(0, state.components.length - 1)
                ],
                customSize: [
                    ...state.customSize.slice(0, state.components.length - 1)
                ]
            };
        case CHANGE_SIZE:
            return {
                ...state,
                customSize: [
                    ...state.customSize.slice(0, state.components.length - 1),
                    action.size
                ]
            };
            break;
        case CHANGE_TITLE:
            return {
                ...state,
                components: [
                    ...state.components.slice(0, state.components.length - 1),
                    {
                        ...state.components[state.components.length - 1],
                        title: action.title
                    }
                ],
            };
            break;
        default:
            return state
    }
}
